import React from "react";
import InfoContainer from "../container/InfoContainer";
import { Grid } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import PropTypes from 'prop-types';
import {
  stripHTML,
  generatePageURI,
  pagePaths,
  handleMissingImg,
  CDN_URI_BASE,
} from "../../common/utilities";
import { useTranslation } from 'react-i18next';
import styles from "./RibbonsMain.module.scss";
import clsx from "clsx";
import { Link } from "react-router-dom";
import missingRibbonImgName from "../../images/_ribbon-missing.jpg";


function RibbonItem(props) {
  const { itemData, hideOnBP } = props;

  const imgPath = `${CDN_URI_BASE}web/ribbons/`;

  return (
    <Grid
      container
      item
      direction="column"
      alignItems="center"
      // spacing={1}
      classes={{
        root: clsx(styles.ribbon_item, !itemData.hasRibbon && styles.disabled)
      }}
    >
      <img
        src={`${imgPath}${itemData.imageFileName}`}
        className={styles.ribbon_img}
        onError={handleMissingImg(`${missingRibbonImgName}`)}
      />
      <h4 className={styles.ribbon_name}>{itemData.ribbonName}</h4>

      <div className={styles.ribbon_desc}>
        <div className={styles.ribbon_desc_text}>
          {stripHTML(itemData.ribbonDescription)}
        </div>
      </div>
    </Grid>
  );
}

//note: ribbonData is an array of ribbon objects
//(objects with info for each ribbon)
function RibbonsMain(props) {
  const { countData, height, ribbonData } = props;
  const { t, i18n } = useTranslation();

  if (ribbonData == null || countData == null) {
    return null;
  }

  const firstHalf = ribbonData.slice(0, 3);
  const secondHalf = ribbonData.slice(3, 6);

  const count = `${countData.playerCNT}/${countData.ribbonCNT}`;

  return (
    <InfoContainer
      headerLeft={<Link to={generatePageURI(pagePaths.RIBBONS)}>{t('Ribbons')}</Link>}
      headerRight={count}
      height={height}
      footer={
        <Link to={generatePageURI(pagePaths.RIBBONS)}>{t('See All Ribbons')}</Link>
      }
      classes={{ footer: styles.footer }}
    >
      <Grid container item className={styles.main_container}>
        <Grid
          container
          direction="column"
          alignItems="center"
          justify="space-between"
          item
          xs={12}
          sm={6}
        >
          {firstHalf.map((item, index) => (
            <RibbonItem itemData={item} key={item.ribbonID} />
          ))}
        </Grid>
        <Hidden only={["xs"]}>
          <Grid
            container
            direction="column"
            alignItems="center"
            justify="space-between"
            item
            xs={12}
            sm={6}
          >
            {secondHalf.map((item, index) => (
              <RibbonItem itemData={item} key={item.ribbonID} />
            ))}
          </Grid>
        </Hidden>
      </Grid>
    </InfoContainer>
  );
}

RibbonsMain.propTypes = {
  countData: PropTypes.object,
  height: PropTypes.string
}

export default RibbonsMain;
